function applyToggleAttributePolyFill() {
  if (!("toggleAttribute" in Element.prototype)) {
    Element.prototype.toggleAttribute = function(attributeName, forceValue) {
      if (typeof forceValue === "undefined") {
        if (this.hasAttribute(attributeName))
          this.removeAttribute(attributeName);
        else
          this.setAttribute(attributeName, "");
      } else if (forceValue)
        this.setAttribute(attributeName, "");
      else
        this.removeAttribute(attributeName);
      return this.hasAttribute(attributeName);
    };
  }
}
export {
  applyToggleAttributePolyFill
};
